import React, { useState } from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import { Link } from "react-router-dom";

const faqs = [
    {
        pergunta: "Como rastreio meu pedido?",
        resposta: "Após a postagem, você receberá um e-mail com o código de rastreio. Também é possível acompanhar em 'Meus Pedidos' na sua conta, onde exibimos o link direto para a transportadora.",
    },
    {
        pergunta: "Qual o prazo de entrega?",
        resposta: "O prazo varia conforme sua região e a transportadora. Na página do produto e no checkout você confere a estimativa. Em geral, entregas em capitais levam de 3 a 10 dias úteis após a confirmação do pagamento.",
    },
    {
        pergunta: "Posso alterar ou cancelar meu pedido?",
        resposta: "Pedidos já confirmados e em processamento podem não ser alterados. Para cancelamento ou alteração, entre em contato o mais rápido possível pelo e-mail ou WhatsApp. Se o pedido ainda não tiver sido enviado, podemos avaliar a solicitação.",
    },
    {
        pergunta: "Quais formas de pagamento são aceitas?",
        resposta: "Aceitamos cartão de crédito (em até 12x) e PIX. O pagamento é processado em ambiente seguro. Para PIX, a confirmação costuma ser imediata.",
    },
    {
        pergunta: "Como devolver ou trocar um produto?",
        resposta: "Consulte nossa Política de Trocas e Devoluções (link no footer). Em resumo: você tem 7 dias para solicitar a devolução ou troca. Entre em contato pelo suporte informando o número do pedido.",
    },
];

export default function Ajuda() {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Box sx={{ bgcolor: "#ffffff", overflowX: "hidden", pb: 8 }}>
            {/* Hero */}
            <Box
                sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    py: { xs: 6, md: 8 },
                    borderRadius: { xs: "0 0 20px 20px", md: "0 0 60px 60px" },
                    textAlign: "center",
                    boxShadow: 3,
                    mb: 6,
                }}
            >
                <Container maxWidth="md">
                    <HelpOutlinedIcon sx={{ fontSize: 48, opacity: 0.9, mb: 1 }} />
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 2, letterSpacing: "-0.03em" }}>
                        Central de Ajuda
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 400, opacity: 0.9, maxWidth: 600, mx: "auto", lineHeight: 1.6 }}>
                        Respostas rápidas para as dúvidas mais comuns. Não encontrou o que precisa? Fale com a gente.
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="md">
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 3, color: "text.primary" }}>
                    Perguntas frequentes
                </Typography>
                {faqs.map((faq, i) => (
                    <Accordion
                        key={i}
                        expanded={expanded === `panel${i}`}
                        onChange={handleChange(`panel${i}`)}
                        elevation={0}
                        sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: "12px !important",
                            mb: 1.5,
                            "&:before": { display: "none" },
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography fontWeight={600}>{faq.pergunta}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2" color="#1e1e1e" sx={{ lineHeight: 1.8 }}>
                                {faq.resposta}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}

                <Paper
                    elevation={0}
                    sx={{
                        mt: 4,
                        p: 4,
                        borderRadius: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        textAlign: "center",
                    }}
                >
                    <ContactSupportOutlinedIcon sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Ainda precisa de ajuda?
                    </Typography>
                    <Typography variant="body2" color="#1e1e1e" sx={{ mb: 3, maxWidth: 480, mx: "auto" }}>
                        Nossa equipe está pronta para atender você por e-mail ou WhatsApp. Horário de atendimento: Segunda a Sexta, 9h às 18h.
                    </Typography>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center" alignItems="center">
                        <Button variant="contained" component={Link} to="/contato" sx={{ textTransform: "none", fontWeight: 700 }}>
                            Enviar mensagem
                        </Button>
                        <Button variant="outlined" href="https://wa.me/5531981020410?text=Ol%C3%A1!%20Vim%20diretamente%20do%20site%20para%20obter%20mais%20informa%C3%A7%C3%B5es!%20%F0%9F%98%8A" target="_blank" rel="noopener noreferrer" sx={{ textTransform: "none", fontWeight: 700 }}>
                            WhatsApp
                        </Button>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}

